var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"js-audioPlayerWrapper",attrs:{"data-key":_vm.dataKey}},[_c('div',{staticClass:"js-audioPlayer message-button",attrs:{"data-type":"button"}})])}
var staticRenderFns = []

export { render, staticRenderFns }